import { useEffect, useState } from 'react';

interface IInputValue {
    readonly isValid: boolean,
    readonly value: string,
    readonly clearInput?: () => void,
}

export const useIsValidForm = (fio: IInputValue, phone: IInputValue): [boolean] => {
    const [isValid, setIsValid] = useState<boolean>(false);
    useEffect(() => {
        setIsValid(fio.isValid && phone.isValid);
    }, [fio, phone]);
    return [isValid];
};
